/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React from 'react';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const AvatarFlat = () => (
    <svg width="59px" height="50px" viewBox="0 0 51 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fillRule="nonzero" fill="#FFFFFF">
                <circle transform="translate(24.780740, 24.608780) rotate(-45.000000) translate(-24.780740, -24.608780) " cx="24.78074" cy="24.60878" r="6.19994054" />
                <circle cx="46" cy="8" r="5"/>
                <circle cx="3" cy="39" r="3"/>
                <path d="M47.2,14.9 C46.8,15 46.4,15 46,15 C44.2,15 42.5,14.3 41.3,13.2 L36.6,17.9 C36.2,18.3 35.6,18.3 35.2,17.9 C34.8,17.5 34.8,16.9 35.2,16.5 L40,11.7 C39.3,10.6 39,9.4 39,8 C39,7 39.2,6 39.6,5.1 C35.5,1.9 30.3,0 24.6,0 C11,0 0,11 0,24.6 C0,28 0.7,31.2 1.9,34.1 C2.3,34 2.6,34 3,34 C4.1,34 5.1,34.4 5.9,35 L9.3,31.6 C9.7,31.2 10.3,31.2 10.7,31.6 L15.4,36.3 L16.6,35.1 C17,34.7 17.6,34.7 18,35.1 C18.4,35.5 18.4,36.1 18,36.5 L16.1,38.4 C15.7,38.8 15.1,38.8 14.7,38.4 L10,33.7 L7.3,36.4 C7.7,37.2 8,38.1 8,39 C8,40.1 7.7,41.1 7.1,41.9 C11.6,46.4 17.8,49.3 24.7,49.3 C38.3,49.3 49.3,38.3 49.3,24.7 C49.3,21.2 48.5,17.9 47.2,14.9 Z M36.3,36.3 C35.9,36.7 35.3,36.7 34.9,36.3 L29.7,31.1 C26.5,33.5 21.9,33.3 19,30.4 C15.8,27.2 15.8,22.1 19,18.9 C22.2,15.7 27.3,15.7 30.5,18.9 C33.5,21.9 33.7,26.6 31.1,29.8 L36.3,35 C36.7,35.3 36.7,35.9 36.3,36.3 Z"/>
            </g>
        </g>
    </svg>
);



// WEBPACK FOOTER //
// ./src/components/atoms/AvatarFlat/index.js